import { render, staticRenderFns } from "./DashboardDefault.vue?vue&type=template&id=65afd828&scoped=true&"
import script from "./DashboardDefault.vue?vue&type=script&lang=js&"
export * from "./DashboardDefault.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDefault.vue?vue&type=style&index=0&id=65afd828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afd828",
  null
  
)

export default component.exports